module.exports = {"breakpoints":{"xs":0,"sm":"576px","md":"768px","lg":"992px","lg-xl":"1366px","lg-xl-xl":"1680px","xl":"1920px"},"colors":{"primary":"#007bff","secondary":"#6c757d","success":"#28a745","info":"#17a2b8","warning":"#ffc107","danger":"#dc3545","light":"#f8f9fa","dark":"#212529","lightgray":"#e4e6e8","darkgray":"darkgray","white":"white","black":"black","red":"#FF4136","gray":"#2B3D4E","gray-light":"#E4E4F0","gray--dark":"#1B2632","orange":"#F54D2E"},"spriteColors":{"white":"white","gray":"gray","black":"black"}}


//////////////////
// WEBPACK FOOTER
// ./src/theme.json
// module id = 7
// module chunks = 0